import React from 'react';
import PropTypes from 'prop-types';
import { IoLogoFacebook } from 'react-icons/io';
import { IoLogoTwitter } from 'react-icons/io';
import { IoLogoLinkedin } from 'react-icons/io';
import { IoLogoInstagram } from 'react-icons/io';
import { IoLogoYoutube } from 'react-icons/io';
import styles from './social-menu.module.css';

const SocialMenu = ({ socialMenuItems }) => {
  const getSocialIcon = key => {
    switch (key) {
      case 'facebook':
        return <IoLogoFacebook />;
      case 'twitter':
        return <IoLogoTwitter />;
      case 'linkedin':
        return <IoLogoLinkedin />;
      case 'instagram':
        return <IoLogoInstagram />;
      case 'youtube':
        return <IoLogoYoutube />;
      default:
        break;
    }
  };

  const renderMenuItems = () => {
    if (socialMenuItems.length) {
      return socialMenuItems.map((item, index) => {
        return (
          <li key={index} className={styles.item}>
            <a
              href={item.url}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={item.object_slug}
              className={styles.link}
            >
              {getSocialIcon(item.object_slug)}
            </a>
          </li>
        );
      });
    }
  };

  return <ul className={styles.list}>{renderMenuItems()}</ul>;
};

SocialMenu.propTypes = {
  socialMenuItems: PropTypes.array,
};

export default SocialMenu;



// WEBPACK FOOTER //
// ./src/components/menus/social-menu/index.js